import React from 'react';
import Header from '../../components/header';
import TermsBody from './body';
import Footer from '../../components/footer';

function Terms(props) {
    document.title = `Yebokenny Terms And Conditions`;
    return (
        <div>
           <Header></Header> 
           <TermsBody></TermsBody>
           <Footer></Footer>
        </div>
    );
}

export default Terms;